import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider, useUser } from './UserContext';
import { LoginPage } from '../features/login/LoginPage';
import { LogPage } from '../features/log/LogPage';
import { FeedPage } from '../features/leaderboard/FeedPage';
import { LeaderboardPage } from '../features/leaderboard/LeaderboardPage';
import { HistoryPage } from '../features/history/HistoryPage';
import { SettingsPage } from '../features/settings/SettingsPage';
import { PwaUpdatePrompt } from '../components/PwaUpdatePrompt/PwaUpdatePrompt';
import { NotificationPrompt } from '../features/notifications/NotificationPrompt';

function AppRoutes() {
  const { user, isLoading, error, emailNotFound, login, createProfile } = useUser();

  // No app-level loading splash — LoginPage handles its own loading/error states.
  // useSyncExternalStore reads localStorage synchronously so there's no init delay.

  if (!user) {
    return (
      <LoginPage
        onLogin={login}
        onCreateProfile={createProfile}
        isLoading={isLoading}
        error={error}
        emailNotFound={emailNotFound}
      />
    );
  }

  return (
    <Routes>
      <Route path="/" element={<LogPage />} />
      <Route path="/feed" element={<FeedPage />} />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <UserProvider>
          <AppRoutes />
          {/* Inside the provider: it only asks once somebody is signed in. */}
          <NotificationPrompt />
        </UserProvider>
      </BrowserRouter>
      <PwaUpdatePrompt />
    </>
  );
}

export default App;
